import { z } from 'zod'

import { zSelect } from 'Lib/zod'

import { FORM_MESSAGES_MAP } from 'Constants/formMessages'

export const hubspotQuestionModalFormSchema = z.object({
  email: z.string().email(FORM_MESSAGES_MAP.EMAIL),
  message: z
    .string()
    .min(1, FORM_MESSAGES_MAP.REQUIRED)
    .max(1000, FORM_MESSAGES_MAP.MAX_LENGTH),
  name: z.string().min(1, FORM_MESSAGES_MAP.REQUIRED),
  reason: zSelect.refine(arg => !!arg?.value, FORM_MESSAGES_MAP.REQUIRED),
})
